import img1 from "../../assets/images/companies/img-1.png";
import img3 from "../../assets/images/companies/img-3.png";
import img2 from "../../assets/images/companies/img-2.png";
import img4 from "../../assets/images/companies/img-4.png";
import img5 from "../../assets/images/companies/img-5.png";

import avtar1 from "../../assets/images/users/avatar-1.jpg";
import avtar2 from "../../assets/images/users/avatar-2.jpg";
import avtar3 from "../../assets/images/users/avatar-3.jpg";
import avtar4 from "../../assets/images/users/avatar-4.jpg";
import avtar6 from "../../assets/images/users/avatar-6.jpg";
import avtar10 from "../../assets/images/users/avatar-10.jpg";
import avtar8 from "../../assets/images/users/avatar-8.jpg";
import avtar9 from "../../assets/images/users/avatar-9.jpg";

const jobWidgets = [
  {
    id: 1,
    lable: "TOTAL JOBS",
    jobs: "36,894",
    series: [95],
    color: '["--vz-success"]',
  },
  {
    id: 2,
    lable: "APPLY JOBS",
    jobs: "28,410",
    series: [97],
    color: '["--vz-success"]',
  },
  {
    id: 3,
    lable: "NEW JOBS",
    jobs: "4,305",
    series: [80],
    color: '["--vz-success"]',
  },
  {
    id: 4,
    lable: "INTERVIEW",
    jobs: "5,021",
    series: [89],
    color: '["--vz-danger"]',
  },
  {
    id: 5,
    lable: "HIRED",
    jobs: "3,948",
    series: [64],
    color: '["--vz-success"]',
  },
  {
    id: 6,
    lable: "REJECTED",
    jobs: "1,340",
    series: [20],
    color: '["--vz-danger"]',
  },
];

const featuredCompany = [
  {
    id: 1,
    img: img1,
    lable: "Force Medicines",
    city: " Cullera, Spain",
    bgColor: "secondary",
  },
  {
    id: 2,
    img: img3,
    lable: "Syntyce Solutions",
    city: "Mughairah, UAE",
    bgColor: "warning",
  },
  {
    id: 3,
    img: img2,
    lable: "Moetic Fashion",
    city: "Mughairah, UAE",
    bgColor: "secondary",
  },
  {
    id: 4,
    img: img4,
    lable: "Meta4Systems",
    city: "Germany",
    bgColor: "danger",
  },
  {
    id: 5,
    img: img5,
    lable: "Themesbrand",
    city: "Bhaktapur",
    bgColor: "danger",
  },
];

const recentApplicants = [
  // {
  //   id: 1,
  //   no: "#VZ2112",
  //   img: avtar1,
  //   name: "Nicholas Ball",
  //   designation: "Assistant / Store Keeper",
  //   rate: "$109.00",
  //   city: "California, US",
  //   type: "Full Time",
  //   typeColor: "success",
  //   rating: "5.0",
  //   ratingDetails : "(245 Rating)"
  // },
  {
    id: 2,
    no: "#VZ2111",
    img: avtar2,
    name: "Elizabeth Allen",
    designation: "Education Training",
    rate: "Rs 5,000K",
    city: "Thimi",
    type: "Freelancer",
    typeColor: "secondary",
    rating: "4.7",
    ratingDetails: "(1.34 Rating)",
  },
  {
    id: 3,
    no: "#VZ2114",
    img: avtar3,
    name: "Cassian Jenning",
    designation: "Graphic Designer",
    rate: "Rs 5,000K",
    city: "Changu",
    type: "Part Time",
    typeColor: "danger",
    rating: "4.5",
    ratingDetails: "(2.93 Rating)",
  },
  {
    id: 4,
    no: "#VZ2117",
    img: avtar4,
    name: "Scott Holt",
    designation: "UI/UX Designer",
    rate: "Rs 5,000K",
    city: "Suryabinayak",
    type: "Part Time",
    typeColor: "danger",
    rating: "2.3",
    ratingDetails: "(4.5 Rating)",
  },
  {
    id: 5,
    no: "#VZ2113",
    img: avtar6,
    name: "Hadley Leonard",
    designation: "React Developer",
    rate: "Rs 5,000K",
    city: "Bhaktapur",
    type: "Full Time",
    typeColor: "success",
    rating: "4.5",
    ratingDetails: "(645 Rating)",
  },
  {
    id: 6,
    no: "#VZ2118",
    img: avtar10,
    name: "Harley Watkins",
    designation: "Project Manager",
    rate: "Rs 5,000K",
    city: "Bhaktapur",
    type: "Freelancer",
    typeColor: "secondary",
    rating: "4.5",
    ratingDetails: "(12 Rating)",
  },
  {
    id: 7,
    no: "#VZ2119",
    img: avtar9,
    name: "Jenson Carlson",
    designation: "Web Designer",
    rate: "Rs 3,000K",
    city: "Bhaktapur",
    type: "Part Time",
    typeColor: "danger",
    rating: "2.5",
    ratingDetails: "(6.3 Rating)",
  },
];
export { jobWidgets, featuredCompany, recentApplicants };
